import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import { Grid } from '@material-ui/core'
import { getEnergyUsedProductionByForm } from '../../../../../../services/Elegibilidad/get'
// import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import { useEligibility } from '../../../../../../context/EligibilityContext'

const Table396 = ({ idElegibilityForm }) => {
  // const {step}= useFormElegibilidad()
  const [state] = useEligibility()

  const [tableData, setTableData] = useState([])

  const getDataTable = async () => {
    try {
      const response = await getEnergyUsedProductionByForm(idElegibilityForm)
      if (response.Code === 200) {
        setTableData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    if (
      state.step === 3 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tableData.length === 0
    ) {
      getDataTable()
    }
  }, [state.step])

  const columns = [
    {
      title: 'Proceso o actividad productiva',
      field: 'ProcessDetail',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'onAdd',
    },
    {
      title: 'Diesel / Gasolina',
      field: 'Diesel_Gasoline',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
    },
    {
      title: 'Leña',
      field: 'Firewood',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
    },
    {
      title: 'Gas',
      field: 'Gas',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
    },
    {
      title: 'Energía eléctrica (servicio nacional o privado)',
      field: 'ElectricPower',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
    },
    {
      title: 'Energía limpias / Renovables',
      field: 'RenewableEnergy',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData}
            // onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              addRowPosition: 'first',
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',
              exportFileName: 'TableData',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              // toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),
              // grouping: true,
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            // icons={{
            //   Add: () => (
            //     <Button
            //       variant="contained"
            //       color="success"
            //       style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
            //       startIcon={<AddIcon style={{ color: 'white' }} />}
            //     >
            //       Agregar otro tipo de energía
            //     </Button>
            //   ),
            //   Edit: () => <EditIcon style={{ color: '#0d53ad' }} />,
            //   Delete: () => <DeleteIcon style={{ color: 'red' }} />,
            // }}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(Table396)
